import React from 'react'
import { Badge } from 'primereact/badge'

const NameTypeBadge = ({ nameType, nameTypeId }) => {
    if (!nameType) return null

    const shade = (nameTypeId || 0) % 10

    return (
        <Badge
            value={nameType}
            className={`custom-badge-base custom-badge-yellow-${shade}`}
        />
    )
}

export default NameTypeBadge
